module.exports = __webpack_public_path__ + "static/media/pov_highlight_face_SmallStellatedDodecahedron.e1457b67.png";